//
// These special values are inserted in the index.html template
// by the server at startup time. This allows us to have a single
// build package for all environments.
//
export const contentUrl = (window as any).CONTENT_URL;
export const cdnUrl     = (window as any).CDN_URL;
export const checkInUrl = (window as any).CHECKIN_URL;
export const s3Bucket   = (window as any).AWS_S3_BUCKET;
export const totpIssuer = (window as any).TOTP_ISSUER;
export const adminRequiresTfa = (window as any).ADMIN_REQUIRES_TFA;
export const minPasswordStrength = (window as any).MIN_PASSWORD_STRENGTH;
export const gaId       = (window as any).GA_ID;
export const sentryRate = (window as any).SENTRY_RATE;
export const sentryEnv  = (window as any).SENTRY_ENV;
export const sentryRelease = (window as any).SENTRY_RELEASE;
export const sentryEnabled = (window as any).SENTRY_ENABLED;
